<template>
    <div class="footer">
        <div class="container">
            <div class="d-flex flex-column flex-xl-row align-items-center justify-content-center justify-content-xl-between">
                <p class="text-center text-xl-start text-copyright mb-xl-0">
                    © 2012-{{currentYear}}. All rights reserved by Northwest Career College. System Developed by <a target="_blank" href="https://www.axilweb.com/">Axilweb.com</a> |
                    <a href="https://www.northwestdrivingschool.com/privacy-policy" target="_blank">Privacy Policy</a>
                </p>
                <div class="d-flex align-items-center">
                    <div class="social-icon facebook">
                        <a target="_blank" href="https://www.facebook.com/nccvegas"><i class="fab fa-facebook-f"></i></a>
                    </div>
                    <div class="social-icon instagram">
                        <a target="_blank" href="https://www.instagram.com/nccvegas/"><i class="fab fa-instagram"></i></a>
                    </div>
                    <div class="social-icon twitter">
                        <a target="_blank" href="https://twitter.com/nccvegas"><i class="fab fa-twitter"></i></a>
                    </div>
                    <div class="social-icon yelp">
                        <a target="_blank" href="https://www.yelp.com/biz/northwest-career-college-las-vegas"><i class="fab fa-yelp"></i></a>
                    </div>
                    <div class="social-icon linkedin">
                        <a target="_blank" href="https://www.linkedin.com/company/nccvegas/"><i class="fab fa-linkedin-in"></i></a>
                    </div>
                    <div class="social-icon snapchat">
                        <a target="_blank" href="https://www.snapchat.com/add/nccvegas"><i class="fab fa-snapchat-ghost"></i></a>
                    </div>
                    <div class="social-icon youtube">
                        <a target="_blank" href="https://www.youtube.com/user/NWCareerCollege?feature=watch"><i class="fab fa-youtube"></i></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Footer',
     data() {
        return {
            currentYear:new Date().getFullYear()
        }
     }
}
</script>
